import type { FaireProductEntity } from "../../entity_types/product";

export const p_rx43nz38kt: FaireProductEntity = {
  token: "p_rx43nz38kt",
  type: "product",
  name: "Nomenclature of Colours Single Playing Card Deck",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/8d92912aa52f81b92ef5d2347b96d47bb65b2fa31b43a2b624d1eebe9c91faf7.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e0ecd7a30484f63bddca35926fc9c2ed2c8abbc57aead271825cf1cf3eeb09e.jpeg",
    "https://cdn.faire.com/fastly/1912004b74a95cf7c76cb3d22983c9d07170fd8e5f9bf8e5e06bf8d46eb14b66.jpeg",
    "https://cdn.faire.com/fastly/99f159decaa3dc460c8b9bd391ef79ef023913881798020fd325ce1ca3123e34.jpeg",
  ],
  priceDollars: 8,
  description:
    "This Single Deck of 52 Playing Cards features ornithologist Robert Ridgway's impressive display of colour swatches from 1886, originally used to standardise the descriptions of colour of birds. Roomytown's design team in Bath, UK, designed each playing card individually, making use of an array of Ridgway's colour swatches. Includes standard 52-card deck plus 2 jokers. Packaged in a stylish portable pull-drawer box, it makes an ideal gift.\n\nH 104mm x W 76.2mm x D 30.4mm / H 4.1\" x W 3.0\" x D 1.2\"",
  tags: [],
  msrpDollars: 17.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:37.901Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
